<template>
  <section class="modal-inner">
    <div class="content-wrap">
      <div class="login">
        <div class="content-header">
          <h2>{{ $t("ログイン") }}</h2>
        </div>

        <div class="warning" id="warning" v-if="errors.length">
          <ul>
            <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
          </ul>
        </div>

        <form id="signin" @submit.prevent="login">
          <input
            v-model="email"
            v-on:blur="instantValidator($event, 'email')"
            name="email"
            :placeholder="this.$root.$t('メールアドレス')"
            id="email"
            autocomplete="email"
            value
            type="text"
            spellcheck="false"
          />
          <p class="caution" id="email-c">{{ emailError }}</p>
          <div class="password-box">
            <input
              v-model="password"
              :type="password_type"
              v-on:blur="instantValidator($event, 'password')"
              :placeholder="this.$root.$t('パスワード')"
              id="u_auth_val"
              autocomplete="new-password"
            />
            <span class="show-hide-password" v-on:click="showHidePassword"
              ><i :class="pass_type_icon"></i
            ></span>
          </div>
          <p class="caution" id="password-c">{{ passError }}</p>

          <p class="txt-right forgot-password">
            <a
              class="text-link text-link-small"
              href="javascript:;"
              @click="sendPasswordResetEmail"
              >{{ $t("パスワードをお忘れの方はこちら") }}</a
            >
          </p>
          <button class="signin-btn" type="submit">{{ $t("ログイン") }}</button>
        </form>

        <div class="txt-center no-account">
          <router-link class="text-link text-link-small" to="register">{{
            $t("アカウントをお持ちでない方はこちら")
          }}</router-link>
        </div>

        <div class="sns_login">
          <a
            class="facebook btn btn-gray-outline"
            v-on:click="facebook_signin"
            id="fb-sign-in"
          >
            <i class="icon-facebook"></i>{{ $t("Sign in with Facebook") }}
          </a>
          <a
            class="googleplus btn btn-gray-outline"
            v-on:click="google_signin"
            id="google-sign-in"
          >
            <span class="google-logo">{{ $t("Sign in with Google") }}</span>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import * as firebase from "firebase/app";
import UserUtil from "@/utils/UserUtils";
import { googleSignInPopup } from "@/auth/google";
import { fbLoginWithPopUp } from "@/auth/facebook";
import * as emailAuth from "@/auth/email-password";
import { sendPasswordReset } from "@/auth/user-meta";
import { mapState, mapGetters, mapMutations } from "vuex";
import { redirectToInheritedPage } from "@/auth/routing";

const loader = document.getElementById("loading");

export default {
  data: () => ({
    email: null,
    password: null,
    errors: [],
    emailError: "",
    passError: "",
    pass_type_icon: "icon-eye-slash",
    password_type: "password",
    loginCheck: true
  }),

  mounted() {
    firebase.auth().onAuthStateChanged(user => {
      const currentUser = user ? user : "";
      if (currentUser && this.loginCheck) this.$router.push("/");
    });
  },
  computed: {
    ...mapState(["clips", "user"]),
    ...mapGetters({
      languageName: "languageName"
    })
  },
  methods: {
    showHidePassword() {
      if (this.password_type === "password") {
        this.password_type = "text";
        this.pass_type_icon = "icon-eye";
      } else {
        this.password_type = "password";
        this.pass_type_icon = "icon-eye-slash";
      }
    },

    toastTopEnd(type, title, text) {
      this.$swal({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 6000,
        type,
        title,
        text
      });
    },

    /**
     * Cognito User Pool Login System
     */
    login() {
      if (!this.checkForm()) return;
      loader.style.display = "block";
      this.loginCheck = false;

      emailAuth
        .SignIn(this.$sanitize(this.email), this.$sanitize(this.password))
        .then(user => {
          // console.log(user)
          let self = this;
          if (!user.user.emailVerified && !user.additionalUserInfo.isNewUser) {
            // loader.style.display = "none";
            this.$swal({
              title: this.$root.$t("User Verification!"),
              text: this.$root.$t(
                "Your email is not verified yet. Please verify your email account."
              ),
              type: "warning",
              showConfirmButton: true,
              showCancelButton: true,
              confirmButtonText: this.$root.$t("Send Verification Email"),
              cancelButtonText: this.$root.$t("キャンセル")
            }).then(res => {
              if (res.value) {
                firebase
                  .auth()
                  .currentUser.sendEmailVerification()
                  .then(() => {
                    self.toastTopEnd(
                      "info",
                      this.$root.$t("Verification mail"),
                      this.$root.$t("sent to your email!")
                    );
                    // self.$router.push("/");
                    redirectToInheritedPage();
                  })
                  .catch(err => {
                    // console.log(err)
                    self.toastTopEnd(
                      "info",
                      this.$root.$t("Error"),
                      this.$root.$t(err.message)
                    );
                  });
              } else {
                redirectToInheritedPage();
                // self.$router.push("/");
                // Jeep Loging / Log out
              }
            });
          } else {
            // loader.style.display = "none";
            this.toastTopEnd(
              "success",
              this.$root.$t("ログイン"),
              this.$root.$t("success")
            );
            redirectToInheritedPage();
            // self.$router.push("/");
          }
        })
        .catch(error => {
          // console.log(error)
          var errorCode = error.code;
          var errorMessage = error.message;

          loader.style.display = "none";
          this.errors.push(this.$root.$t(errorMessage));
        });
    },

    facebook_signin() {
      loader.style.display = "block";
      let additional_data = {
        language_id: UserUtil.convertToLanguageId(
          this.$store.state.languageName
        )
      };

      fbLoginWithPopUp(additional_data)
        .then(result => {
          // console.log(result)
          // loader.style.display = "none";
          this.toastTopEnd(
            "success",
            this.$root.$t("ログイン"),
            this.$root.$t("success")
          );
          // this.$router.push("/");
          redirectToInheritedPage();
        })
        .catch(error => {
          // console.log(error)
          if (error.code === "auth/account-exists-with-different-credential") {
            this.existingAccountMergeForSNS(error)
              .then(res => {
                // console.log(res)
                // loader.style.display = "none";
                redirectToInheritedPage();
                // this.$router.push("/");
              })
              .catch(err => {
                loader.style.display = "none";
              });
          } else {
            var errorCode = error.code;
            var errorMessage = error.message;
            loader.style.display = "none";

            this.errors.push(this.$root.$t(errorMessage));
          }
        });
    },

    google_signin() {
      loader.style.display = "block";
      let additional_data = {
        language_id: UserUtil.convertToLanguageId(
          this.$store.state.languageName
        )
      };

      googleSignInPopup(additional_data)
        .then(result => {
          // console.log(result.user)
          // loader.style.display = "none";
          this.toastTopEnd(
            "success",
            this.$root.$t("ログイン"),
            this.$root.$t("success")
          );
          // this.$router.push("/");
          redirectToInheritedPage();
        })
        .catch(error => {
          // console.log(error)
          if (error.code === "auth/account-exists-with-different-credential") {
            this.existingAccountMergeForSNS(error)
              .then(res => {
                // console.log(res)
                // loader.style.display = "none";
                // this.$router.push("/");
                redirectToInheritedPage();
              })
              .catch(err => {
                loader.style.display = "none";
              });
          } else {
            var errorCode = error.code;
            var errorMessage = error.message;
            loader.style.display = "none";

            this.errors.push(this.$root.$t(errorMessage));
          }
        });
    },

    existingAccountMergeForSNS(error) {
      return new Promise((resolve, reject) => {
        if (error.code === "auth/account-exists-with-different-credential") {
          var pendingCred = error.credential;
          var email = error.email;
          var auth = firebase.auth();

          // Get sign-in methods for this email.
          auth.fetchSignInMethodsForEmail(email).then(methods => {
            // console.log(methods)
            if (methods[0] === "password") {
              // Alert: You have existing account with the same email via password credentials.
              // Alert: Please input existing account password to continue.
              this.$swal({
                title: this.$root.$t("Account already exist!"),
                text: this.$root.$t(
                  "You have existing account with the same email via password credentials. Please input existing account password to continue with merge this account to existing account."
                ),
                input: "password",
                showCancelButton: true,
                confirmButtonText: this.$root.$t("Login & Merge"),
                // showLoaderOnConfirm: true,
                allowOutsideClick: false
              }).then(result => {
                // console.log(result.value)
                if (result.value) {
                  var password = this.$sanitize(result.value);

                  auth
                    .signInWithEmailAndPassword(email, password)
                    .then(user => {
                      auth.currentUser
                        .linkWithCredential(pendingCred)
                        .then(res => {
                          this.$swal({
                            title: this.$root.$t("ユーザー登録"),
                            text: this.$root.$t(
                              "Your account successfully linked to the existing user."
                            ),
                            type: "success"
                          });
                          // console.log(res);
                          resolve(res);
                        });
                    })
                    .catch(err => {
                      var errorCode = err.code;
                      var errorMessage = err.message;

                      this.$swal({
                        title: this.$root.$t("ユーザー登録"),
                        text: this.$root.$t(errorMessage),
                        type: "error"
                      });
                      reject(err);
                    });
                }
              });
            } else {
              var provider =
                methods[0] === "google.com"
                  ? new firebase.auth.GoogleAuthProvider()
                  : new firebase.auth.FacebookAuthProvider();
              var message =
                methods[0] === "facebook.com"
                  ? this.$root.$t(
                      "You’ve already used this email for facebook sign in. Sign in with Facebook to continue."
                    )
                  : this.$root.$t(
                      "You’ve already used this email for google sign in. Sign in with Google to continue."
                    );

              this.$swal({
                title: this.$root.$t("Account already exist!"),
                text: message,
                showCancelButton: true,
                confirmButtonText: this.$root.$t("Login & Merge"),
                // showLoaderOnConfirm: true,
                allowOutsideClick: false
              }).then(result => {
                if (result.value) {
                  auth
                    .signInWithPopup(provider)
                    .then(res => {
                      auth.currentUser
                        .linkAndRetrieveDataWithCredential(pendingCred)
                        .then(usercred => {
                          this.$swal({
                            title: this.$root.$t("ユーザー登録"),
                            text: this.$root.$t(
                              "Your account successfully linked to the existing user."
                            ),
                            type: "success"
                          });
                          // console.log(usercred);
                          resolve(usercred);
                        });
                    })
                    .catch(err => {
                      var errorCode = err.code;
                      var errorMessage = err.message;

                      this.$swal({
                        title: this.$root.$t("ユーザー登録"),
                        text: this.$root.$t(errorMessage),
                        type: "error"
                      });
                      reject(err);
                    });
                }
              });
            }
          });
        }
      });
    },

    sendPasswordResetEmail() {
      loader.style.display = "block";
      this.$swal({
        title: this.$root.$t("Password Reset"),
        text: this.$root.$t("Submit you email address to get password link."),
        input: "email",
        showCancelButton: true,
        cancelButtonText: this.$root.$t("キャンセル"),
        confirmButtonText: this.$root.$t("Send"),
        allowOutsideClick: false,
        inputValidator: value => {
          if (!value) return this.$root.$t("Email field is empty.");
        },
        validationMessage: email => {
          return this.$root.$t("Invalid email adrress.");
        }
      }).then(result => {
        // console.log(result.value)
        if (result.value) {
          sendPasswordReset(
            this.$sanitize(result.value),
            UserUtil.uniStyleLang(this.languageName)
          )
            .then(res => {
              loader.style.display = "none";
              this.$swal({
                title: this.$root.$t("Password Reset"),
                text: this.$root.$t(
                  "A password reset link sent to your email."
                ),
                type: "success"
              });
            })
            .catch(err => {
              loader.style.display = "none";
              this.$swal({
                title: this.$root.$t("Password Reset"),
                text: this.$root.$t(err.message),
                type: "error"
              });
            });
        } else {
          loader.style.display = "none";
        }
      });
    },

    instantValidator(el, type) {
      if (type === undefined) return;
      if (type === "email") {
        if (!this.email) {
          this.emailError = this.$root.$t("Email field is empty.");
        } else if (!this.emailValidator(this.email)) {
          this.emailError = this.$root.$t("Invalid email adrress.");
        } else {
          this.emailError = "";
        }
      } else if (type === "password") {
        if (!this.password) {
          this.passError = this.$root.$t("Password field is empty.");
        } else if (!this.passwordValidator(this.password)) {
          if (this.password.length < 6) {
            this.passError = this.$root.$t(
              "Please set a password with more than 6 characters."
            );
          } else if (this.password.length > 16) {
            this.passError = this.$root.$t(
              "Please set a password with less than 16 characters."
            );
          } else if (
            !/^(?=.*?[a-zA-Z])(?=.*\d)([a-zA-Z0-9])+$/.test(this.password)
          ) {
            this.passError = this.$root.$t(
              "Password should contain both alphabets and numbers."
            );
          } else {
            this.passError = this.$root.$t("Invalid password format.");
          }
        } else {
          this.passError = "";
        }
      }
    },

    checkForm: function(e) {
      this.errors = [];
      if (!this.email) {
        this.errors.push(this.$root.$t("Please input a valid email address."));
      } else if (!this.validEmail(this.email)) {
        this.errors.push(this.$root.$t("Invalid email adrress."));
      }
      if (!this.password)
        this.errors.push(this.$root.$t("Please input a valid password."));
      if (!this.errors.length) return true;
    },

    passwordValidator: function(pass) {
      if (!pass) return false;
      var re = /^(?=.*?[a-zA-Z])(?=.*\d)([a-zA-Z0-9]).{5,16}$/; //previous one : /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
      return re.test(pass);
    },

    validEmail: function(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    emailValidator: function(email) {
      if (!email) return false;
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  },

  //For Header & Meta Tag
  metaInfo() {
    return {
      title: this.$root.$t("ログイン") + " | MATCHA - JAPAN TRAVEL WEB MAGAZINE"
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/users/login.vue